import { render, staticRenderFns } from "./OrdersToReceive.vue?vue&type=template&id=75e5c58f&"
import script from "./OrdersToReceive.vue?vue&type=script&lang=js&"
export * from "./OrdersToReceive.vue?vue&type=script&lang=js&"
import style0 from "./OrdersToReceive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports